import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { StockInRepository } from './repositories/stock-in-repositories';
import { StockInEntity } from './stock-in.entity';
import { WarehouseService } from './warehouse.service';
// import { ScheduleModule } from '@nestjs/schedule';
import { WarehouseController } from './warehouse.controller';
import { ProductionCostAnalysisEntity } from './production-cost-analysis.entity';
import { RMPurchaseAnalysisEntity } from './rm_purchase_analysis.entity';
import { CronInfo } from './cron-info.entity';
import { DaywiseOpeningStockEntity } from './daywise-opening-stock.entity';
import { DaywiseShrimpAnalysisEntity } from './daywise-shrimp-analysis.entity';
import { MontlyMisEntity } from './montly-mis.entity';
import { ForkLiftJobService } from '@gtpl/shared-services/warehouse-management';
import { ScheduleModule } from '@nestjs/schedule';
import { BaleAmtInfo } from './bale-amt-info.entity';


@Module({
  imports: [
    TypeOrmModule.forFeature([StockInEntity,StockInRepository,ProductionCostAnalysisEntity,RMPurchaseAnalysisEntity,CronInfo,DaywiseOpeningStockEntity,DaywiseShrimpAnalysisEntity,MontlyMisEntity,BaleAmtInfo]),
    ScheduleModule.forRoot(),

  ],
  controllers: [WarehouseController],
  providers: [WarehouseService, ApplicationExceptionHandler,ForkLiftJobService]
})
export class WarehouseModule {}
